import { Table } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import {
	QUES_CODE_PREFIX,
	formatBrsrNumericCellValue,
	renderQuestionAnswer,
	renderType1TableAnswerForCurrentYear,
	renderType3TableAnswerForCurrentYear
} from '../../../../core/utilities/BRSRUtils';
import './../Reporting.scss';

const BRSRPrinciple1 = ({
	t,
	page3,
	yearFilter
}) => {

	const renderType1TableAnswerForCurrentYearWrapper = (qIndex, colNos) => {
		return renderType1TableAnswerForCurrentYear(page3, 3, qIndex, colNos);
	};

	const renderTableAnswerForCurrentYearWrapper = (qIndex, colNos) => {
		const block = page3.currentYear?.[QUES_CODE_PREFIX + qIndex];
		if (block?.keyValueType === 'TYPE_3_TABLE') {
			const type3 = renderType3TableAnswerForCurrentYear(page3, 4, qIndex, colNos);
			if (type3 != null) return type3;
		}
		return renderType1TableAnswerForCurrentYear(page3, 4, qIndex, colNos);
	};

	const renderP1Q1 = () => {
		const currentYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>1. Percentage coverage by training and awareness programmes on any of the Principles during the financial year:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Segment</th>
								<th>Total number of training and awareness programmes held</th>
								<th>Topics / principles covered under the training and its impact </th>
								<th>% age of persons in respective category covered by the awareness programmes</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Board of directors</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1aa'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1ab'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1ac'] ?? ''}</td>
							</tr>
							<tr>
								<td>Key Managerial Personnel</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1ba'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1bb'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1bc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Employees other than BoD and KMPs</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1ca'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1cb'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1cc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Workers</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1da'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1db'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-1dc'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP1Q2Part1 = () => {
		const currentYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<Table bordered size="sm">
				<thead>
					<tr>
						<th></th>
						<th>NGRBC Principle </th>
						<th>Name of the regulatory/ enforcement agencies/ judicial institutions </th>
						<th>Amount (In INR) </th>
						<th>Brief of the Case</th>
						<th>Has an appeal been preferred? (Yes/No) </th>
					</tr>
				</thead>
				<tbody>
					{renderTableAnswerForCurrentYearWrapper('P1-2-2a', ['a', 'b', 'c', 'd', 'e', 'f'])}					
				</tbody>
			</Table>
		);
	};

	const renderP1Q2Part2 = () => {
		const currentYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<Table bordered size="sm">
				<thead>
					<tr>
						<th></th>
						<th>NGRBC Principle </th>
						<th>Name of the regulatory/ enforcement agencies/ judicial institutions </th>
						<th>Brief of the Case</th>
						<th>Has an appeal been preferred? (Yes/No) </th>
					</tr>
				</thead>
				<tbody>					
					{renderTableAnswerForCurrentYearWrapper('P1-2-2b', ['a', 'b', 'c', 'd', 'e'])}						
				</tbody>
			</Table>
		);
	};

	const renderP1Q3 = () => {
		const currentYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>3. Of the instances disclosed in Question 2 above, details of the Appeal/ Revision preferred in cases where monetary or non-monetary action has been appealed.</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Case Details</th>
								<th>Name of the regulatory/ enforcement agencies/ judicial institutions </th>
							</tr>
						</thead>
						<tbody>
							{renderType1TableAnswerForCurrentYearWrapper('P1-3', ['a', 'b'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP1Q4 = () => {
		const currentYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer(
			'4. Does the entity have an anti-corruption or anti-bribery policy? If yes, provide details in brief and if available, provide a web-link to the policy.',
			currentYearAnswer[QUES_CODE_PREFIX + 'P1-4a'] ?? ''
		);
	};

	const renderP1Q5 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-5']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page3?.['previousYear']) {
			page3['previousYear'][QUES_CODE_PREFIX + 'P1-5']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>5. Number of Directors/KMPs/employees/workers against whom disciplinary action was taken by any law enforcement agency for the charges of bribery/ corruption:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th className='FY_class white-nowrap'>FY ({yearFilter}) </th>
								<th className='white-nowrap'>FY ({yearFilter - 1})</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Directors</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-5a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-5a'] ?? ''}</td>
							</tr>
							<tr>
								<td>KMPs</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-5b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-5b'] ?? ''}</td>
							</tr>
							<tr>
								<td>Employees</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-5c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-5c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Workers</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-5d'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-5d'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP1Q6 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-6']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page3?.['previousYear']) {
			page3['previousYear'][QUES_CODE_PREFIX + 'P1-6']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>6. Details of complaints with regard to conflict of interest:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan={1}></th>
								<th colSpan={2} className="text-center FY_class white-nowrap">FY ({yearFilter})</th>
								<th colSpan={2} className="text-center white-nowrap">FY ({yearFilter - 1})</th>
							</tr>
							<tr>
								<th></th>
								<th className='FY_class_sub'>Number </th>
								<th className='FY_class_sub'>Remarks </th>
								<th>Number </th>
								<th>Remarks </th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Number	of complaints received in relation to issues of Conflict of Interest of the Directors </td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-6aa'] ?? ''}</td>
								<td className='FY_class_content'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-6ab'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-6aa'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-6ab'] ?? ''}</td>
							</tr>
							<tr>
								<td>Number	of complaints received in relation to issues of Conflict of Interest of the KMPs</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-6ba'] ?? ''}</td>
								<td className='FY_class_content'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-6bb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-6ba'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-6bb'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP1Q7 = () => {
		const currentYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-7']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer(
			'7. Provide details of any corrective action taken or underway on issues related to fines / penalties / action taken by regulators/ law enforcement agencies/ judicial institutions, on cases of corruption and conflicts of interest.',
			currentYearAnswer[QUES_CODE_PREFIX + 'P1-7a'] ?? ''
		);
	};

	const renderP1Q8 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-8']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page3?.['previousYear']) {
			page3['previousYear'][QUES_CODE_PREFIX + 'P1-8']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>8. Number of days of accounts payables ((Accounts payable *365) / Cost of goods/services procured) in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th className='FY_class white-nowrap'>FY ({yearFilter}) </th>
								<th className='white-nowrap'>FY ({yearFilter - 1})</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Number of days of accounts payables</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-8a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-8a'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP1Q9 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-9']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page3?.['previousYear']) {
			page3['previousYear'][QUES_CODE_PREFIX + 'P1-9']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>
					<p className='mb-1'>9. Open-ness of business</p>
					<p>Provide details of concentration of purchases and sales with trading houses, dealers, and related parties along-with loans and advances & investments, with related parties,
						in the following format:</p>
				</b>
				<div>
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Parameter </th>
								<th>Metrics  </th>
								<th className='FY_class white-nowrap'>FY ({yearFilter})</th>
								<th className='white-nowrap'>FY ({yearFilter - 1}) </th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td rowSpan="3">Concentration of Purchases </td>
								<td>
									<div className="table_list01">
										a. Purchases from trading  houses as % of total purchases
									</div>
								</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-9a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-9a'] ?? ''}</td>
							</tr>
							<tr>
								<td>
									<div className="table_list01">
										b. Number of trading houses	where purchases are made from
									</div>
								</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-9b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-9b'] ?? ''}</td>
							</tr>
							<tr>
								<td>
									<div className="table_list01">
										c. Purchases from top 10 trading houses as % of total  purchases  from trading houses
									</div>
								</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-9c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-9c'] ?? ''}</td>
							</tr>
							<tr>
								<td rowSpan="3">Concentration of Sales  </td>
								<td>
									<div className="table_list01">
										a. Sales	to	dealers	/ distributors as % of total sales
									</div>
								</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-9d'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-9d'] ?? ''}</td>
							</tr>
							<tr>
								<td>
									<div className="table_list01">
										b. Number of dealers / distributors to whom sales are made
									</div>
								</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-9e'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-9e'] ?? ''}</td>
							</tr>
							<tr>
								<td>
									<div className="table_list01">
										c. Sales to top 10 dealers / distributors as % of total sales to dealers / distributors
									</div>
								</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-9f'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-9f'] ?? ''}</td>
							</tr>
							<tr>
								<td rowSpan="4">Share of RPTs in   </td>
								<td>
									<div className="table_list01">
										a. Purchases (Purchases with related parties / Total Purchases)
									</div>
								</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-9g'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-9g'] ?? ''}</td>
							</tr>
							<tr>
								<td>
									<div className="table_list01">
										b. Sales (Sales to related parties / Total Sales)
									</div>
								</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-9h'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-9h'] ?? ''}</td>
							</tr>
							<tr>
								<td>
									<div className="table_list01">
										c. Loans & advances (Loans & advances given to related parties / Total loans & advances)
									</div>
								</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-9i'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-9i'] ?? ''}</td>
							</tr>
							<tr>
								<td>
									<div className="table_list01">
										d. Investments ( Investments in related parties / Total Investments made)
									</div>
								</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-9j'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P1-9j'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP1LI1 = () => {
		const currentYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-LI1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>1. Awareness programmes conducted for value chain partners on any of the Principles during the financial year:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Total number of awareness programmes held</th>
								<th>Topics / principles covered under the training</th>
								<th>%age of value chain partners covered (by value of business done with such partners) under the awareness programmes</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-LI1a'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-LI1b'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P1-LI1c'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP1LI2 = () => {
		const currentYearAnswer = {};
		if (page3?.['currentYear']) {
			page3['currentYear'][QUES_CODE_PREFIX + 'P1-LI2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className="brsr-p1-li2-qa">
				{renderQuestionAnswer(
					'2. Does the entity have processes in place to avoid/ manage conflict of interests involving members of the Board? (Yes/No) If Yes, provide details of the same.',
					currentYearAnswer[QUES_CODE_PREFIX + 'P1-LI2a'] ?? ''
				)}
			</div>
		);
	};

	return (
		<section id="PRINCIPLE_1" className="Main_Section PRINCIPLE_1">
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_head mb-3">
						<h5>PRINCIPLE 1 Businesses should conduct and govern themselves with integrity, and in a manner that is Ethical, Transparent and Accountable.  </h5>
					</div>
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head mb-3">
								<b>Essential Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP1Q1()}
									<div className='brsr-list-item'>
										<b>
											2. Details of fines / penalties /punishment/ award/ compounding fees/ settlement amount paid in proceedings (by the entity or by directors / KMPs) with regulators/ law enforcement agencies/ judicial institutions, in the financial year, in the following format (Note: the entity shall make disclosures on the basis of materiality as specified in Regulation 30 of SEBI (Listing Obligations and Disclosure Obligations) Regulations, 2015 and as disclosed on the entity's website):
										</b>
										<div className='mt-4'>
											<div className="ETA_card_Section_sub_head ps-0 mb-3">
												<b>Monetary </b>
											</div>
											<div className="ETA_card_Section_sub_body ps-0">
												<div className='ps-0'>
													{renderP1Q2Part1()}
												</div>
											</div>
										</div>
										<div className='mt-4'>
											<div className="ETA_card_Section_sub_head ps-0 mb-3">
												<b>Non-Monetary  </b>
											</div>
											<div className="ETA_card_Section_sub_body ps-0">
												<div className="mt-2 ps-0">
													{renderP1Q2Part2()}
												</div>
											</div>
										</div>
									</div>
									{renderP1Q3()}
									{renderP1Q4()}
									{renderP1Q5()}
									{renderP1Q6()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP1Q7()}
									{renderP1Q8()}
									{renderP1Q9()}
								</div>
							</div>
							<div className="ETA_card_Section_sub_head mb-3">
								<b>Leadership Indicators </b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP1LI1()}
									{renderP1LI2()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRPrinciple1);
